import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const NotFound = () => {
    return (
        <>
            <Helmet>
                <title>Page Not Found | Isadora Beans</title>
                <meta name='robots' content='noindex, follow' />
            </Helmet>
            <section className='container py-5 text-center'>
                <h1>Page not found</h1>
                <p>
                    The page you are looking for does not exist or has moved.
                </p>
                <p>
                    <Link to='/'>Go to home</Link> ·{' '}
                    <Link to='/products'>See our products</Link> ·{' '}
                    <Link to='/recipes'>Find a recipe</Link>
                </p>
            </section>
        </>
    );
};

export default NotFound;
